module.exports = __webpack_public_path__ + "static/media/share-icon.a1ae532f.svg";